import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getVegPhasesPhyto.success: {
            return action.payload;
        }

        case constants.getVegPhasesPhyto.error: {
            return initialState;
        }

        case constants.getVegPhasesPhyto.try: {
            return {};
        }

        default:
            return state;
    }
}